module.exports = __webpack_public_path__ + "img/bg_01.770cf959.jpg";